import './Dropdown.scss';

import checkmark from '../../assets/images/icons/check-mark.svg';

function Dropdown({ type, data, setter, valueSet }) {

    function toggleCheckboxOption(opt) {
        if (valueSet.includes(opt)) {
            setter(valueSet.filter((item) => item !== opt));
        } else {
            setter([...valueSet, opt]);
        }
    }

    if (type === 'radio') {
        return (
            <div className='dropdown'>
                <div className='dropdown__info'>
                    {
                        data.map((option, index) => (
                            <div
                                key={index}
                                className='dropdown__field'
                                onClick={() => setter(option)}
                            >
                                <div
                                    className={(valueSet === option) ? 'dropdown__field-circle dropdown__field-circle--selected' : 'dropdown__field-circle'}
                                >
                                    <div className={(valueSet === option) ? 'dropdown__field-circle--selected-inner' : 'dropdown__field-circle-inner'}></div>
                                </div>

                                <p className='dropdown__field-value'>
                                    {option}
                                </p>
                            </div>
                        ))
                    }

                </div>
            </div>
        )
    }

    if (type === 'checkbox') {
        return (
            <div className='dropdown'>
                <div className='dropdown__info'>
                    {
                        data.map((option, index) => (
                            <div
                                key={index}
                                className='dropdown__field'
                                onClick={() => toggleCheckboxOption(option)}
                            >
                                <div
                                    className={valueSet.includes(option) ? 'dropdown__field-box dropdown__field-box--selected' : 'dropdown__field-box'}
                                >
                                    {
                                        valueSet.includes(option) && <img src={checkmark} alt='white checkmark'></img>
                                    }
                                </div>
                                <p>{option}</p>
                            </div>
                        ))
                    }

                </div>
            </div>
        )
    }

    return (
        <>
        </>
    )

    // const [radio, setRadio] = useState(false);
    // const [checkbox, setCheckbox] = useState(false);
    // const [calendar, setCalendar] = useState(false);

    // // const [selectedGender, setSelectedGender] = useState('Female')

    // useEffect(() => {
    //     switch (type) {
    //         case 'radio':
    //             setRadio(true);
    //             break;
    //         case 'checkbox':
    //             setCheckbox(true);
    //             break;
    //         case 'calendar':
    //             setCalendar(true);
    //             break;
    //         default:
    //             break;
    //     }
    // }, [type]);

    // function handleRadioChange(event) {
    //     setter(event.target.value);
    //     // console.log(event.target.value);
    // }

    // function RadioButton({ value, checked, onChange, label }) {
    //     return (
    //         <label className="radioButton">
    //             <input
    //                 type="radio"
    //                 value={value}
    //                 // checked={checked}
    //                 onChange={onChange}
    //             />
    //             <span className="radioCustom"></span>
    //             {label}
    //         </label>
    //     )
    // }

    // return (
    //     <section className="dropdown">
    //         <div className='dropdown__info'>
    //             {radio &&
    //                 <form className='dropdown__info-form'>
    //                     {
    //                         data.map((thing, index) => (
    //                             // <div key={index} className='dropdown__info-form-info'>
    //                             //     <input
    //                             //         type="radio"
    //                             //         value={thing}
    //                             //         checked={valueSet === data[index]}
    //                             //         onChange={handleRadioChange}
    //                             //         id="radio-button"
    //                             //         className='dropdown__info-form-info-input' />
    //                             //     <label htmlFor="radio-button" className='dropdown__info-form-info-text'>{thing}</label>
    //                             // </div>
    //                             <RadioButton key={index} value={thing} checked={valueSet === data[index]} onChange={handleRadioChange} label={thing} />

    //                         ))
    //                     }
    //                 </form>
    //             }
    //             {checkbox &&
    //                 <form className='dropdown__info-form'>
    //                     {
    //                         data.map((thing, index) => (
    //                             <div key={index} className='dropdown__info-form-info'>
    //                                 {/* <input type='checkbox' id='check-box' className='dropdown__info-form-info-input' /> */}

    //                                 <label htmlFor='check-box' className='dropdown__info-form-info-text'>{thing}</label>
    //                             </div>
    //                         ))
    //                     }
    //                 </form>
    //             }
    //             {calendar &&
    //                 <Calendar className='dropdown__info-calendar' />
    //             }
    //         </div>

    //     </section>
    // )
}

export default Dropdown;